export default [
  {
    name: 'approvePage',
    method: 'POST',
    path: '/vue/account-waitApprove/account-page'
  },
  {
    name: 'approveUpdateStatus',
    method: 'POST',
    path: '/vue/account-waitApprove/account-update-status'
  }
];
